
import { defineComponent } from 'vue';
import HakoButton from '@hakosalo/hakolib';
import HakoBsIcon from '@hakosalo/hakolib';
import { HakoModal } from '@hakosalo/hakolib';
import GuideCreation from './modals/GuideCreation.vue';
import AskCategoryRemoval from './modals/AskCategoryRemoval.vue';
import AskGuideRemoval from './modals/AskGuideRemoval.vue';
import CategoryCreation from '@/components/modals/CategoryCreation.vue';
import axios from 'axios';
import draggable from 'vuedraggable';
import { mapState } from 'pinia';
import { useGuideIdStore } from '@/stores/guideIdStore';

export default defineComponent({
	name: 'CategoryList',
	emits: ["logoutemit", "toggle-panel", "categories"],
	components: {
		HakoButton,
		GuideCreation,
		CategoryCreation,
		HakoModal,
		HakoBsIcon,
		AskCategoryRemoval,
		AskGuideRemoval,
		draggable,
	},
	data() {
		return {
			showGuideCreation: false as boolean,
			showCategoryCreation: false as boolean,
			showCategoryDeletion: false as boolean,
			showCategoryEdit: false as boolean,
			showGuideDeletion: false as boolean,
			categories: [] as any[],
			chosenCategoryId: null as number | null,
			chosenCategory: null as any,
			chosenGuide: null as any,
			openCategories: [] as number[],
			orderEdit: false as boolean,
			drag: false as boolean,
		}
	},
	mounted() {
		this.getCategoriesFromDb();
	},
	computed: {
		...mapState(useGuideIdStore, ["guideid"]),
		cGuideId() {
			return this.guideid; 
		},
	},
	watch: {
		cGuideId() {
			if (!this.cGuideId) return;
			let category = null as any;
			this.categories.forEach((cat) => {
				if (cat.guides.map((e: any) => e.id).includes(this.cGuideId)) {
					category = cat;
					this.openCategories.push(cat.id);
				}
				cat.children.forEach((child:  any) => {
					if (child.guides.map((e: any) => e.id).includes(this.cGuideId)) {
						category = child;
						this.openCategories.push(child.id)
					}
				})
			})
		}
	},
	// watch above thing?
	methods: {
		logOut() {
			this.$emit('logoutemit');
		},
		goToControlPanel() {
			this.$router.push('/ohjauspaneeli');
		},
		getCategoriesFromDb() {
			if(this.$userIsSuper()) {
				axios.get('Guide/AllCategories').then(resp => {
					this.categories = resp.data;
					this.showCategoryDeletion = false;
					this.showCategoryCreation = false;
					this.showGuideCreation = false;
					this.showGuideDeletion = false;
					this.$emit('categories', this.categories)
				})
				return
			}
			axios.get('Guide/PublishedCategories').then(resp => {
				this.categories = resp.data;
				this.showCategoryDeletion = false;
				this.showCategoryCreation = false;
				this.showGuideCreation = false;
				this.showGuideDeletion = false;
				this.$emit('categories', this.categories)
			})
		},
		addNewCategory() {
			(this.$refs.category as InstanceType<typeof CategoryCreation>).addNewCategory();
		},
		isCategoryOpen(id: number) {
			if (this.openCategories.indexOf(id) !== -1) {
				return true
			}
			return false
		},
		isSelectedGuide(guide: any) {
			if (this.guideid == guide.id && !guide.categoryRoot) {
				return "selected"
			}
			return ""
		},
		isSelectedCategoryGuide(rootguideid: number) {
			if (this.guideid == rootguideid) {
				return "selected"
			}
			return ""
		},
		toggleCategory(category: any) {
			if (this.isCategoryOpen(category.id) === true) {
				this.openCategories = this.openCategories.filter(x => x !== category.id);				
			}
			else {
				this.openCategories.push(category.id);
			}

			if(category.guides){
				let rootGuide = category.guides.find((x : any) => x.categoryRoot == true);
				this.$router.push('/artikkeli/'+rootGuide.id);
			}
		},
		openGuide(id: number) {
			this.$router.push('/artikkeli/'+id);
		},
		categoryChevron(categoryId: number) {
			if(this.openCategories.indexOf(categoryId) === -1) {
				return "chevron-right"
			}
			return "chevron-down"
		},
		createNewCategory() {
			this.chosenCategory = null;
			this.chosenCategoryId = null;
			this.showCategoryCreation = true;
		},
		addMissingRootGuides() {
			axios.post("Guide/AddMissingRootGuides", this.categories)
			.then(resp => alert("success: " + resp.data))
			.catch(err => console.log(err))
		},
		createNewGuide(category: any) {
			if (category) {
				this.chosenCategory = category;
			}
			this.chosenGuide = null;
			this.showGuideCreation = true;
		},
		deleteCategory(category: any) {
			this.chosenCategory = category;
			this.showCategoryDeletion = true;
		},
		editCategory(category: any) {
			this.chosenCategory = category;
			this.showCategoryCreation = true;
		},
		editGuide(guide: any, categoryid: number) {
			this.chosenGuide = guide;
			this.categories.forEach(top => {
				if (top.id == categoryid) {
					this.chosenCategory = top;
				}
				top.children.forEach((child: any) => {
					if (child.id == categoryid) {
						this.chosenCategory = child
					}
				})
			})
			this.showGuideCreation = true;
		},
		deleteGuide(guide: any) {
			this.chosenGuide = guide;
			this.showGuideDeletion = true;
		},
		updateOrderIndexes() {
			this.categories.forEach((category, index) => {
				category.orderIndex = index;
			})
			axios.post("Guide/SaveCategoryOrder", this.categories)
			.then(resp => console.log(resp.data))
			.catch(err => console.log(err))
		}
	}
});
